import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useMediaQuery } from "@mui/material";

import { GetPrograms } from "../../../redux/v2/program/actions";
import CustomModalWrapper from "../../../common/CustomModalV2/wrapper";
import CustomButton from "../../../common/CustomButton";
import PaddedContentArea from "../../../common/PaddedContentArea";
import ProgramDetail from "../../onboarding/Components/ProgramDetail";
import ProgramsList from "../../onboarding/Components/ProgramsList";
import { ScreenType } from "../../../utils/breakpoints";
import { delay, removeItemInArray } from "../../../utils";
import CloseButton from "../../../common/CloseButton";
import { GenerateSchedule } from "../../../redux/v2/user/actions";
import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";
import ChooseProgram from "../../user-survey/components/ChooseProgram";
import { useLocation } from "react-router-dom";

function SlideSelectProgram(props) {
    const location = useLocation();
    const screenSize = ScreenType(useMediaQuery);
    const { displayType = 2, userSessionID } = props;

    const [addedProgram, setAddedProgram] = useState([]);
    const [addedProgramIDs, setAddedProgramIDs] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState(null);

    const [choosenPrograms, setChoosenPrograms] = useState([]);
    const [choosenProgramIDs, setChoosenProgramIDs] = useState([]);
    const [selectedProgram2, setSelectedProgram2] = useState(null);

    const [slide, setSlide] = useState(false);
    const [delaySlide, setDelay] = useState(null);
    const [arrangedPrograms, setArrangedPrograms] = useState([]);

    const updateAddedPrograms = (program) => {
        let temp = [...addedProgram];
        const index = temp.findIndex((p) => p.id === program.id);
        if (index === -1) {
            temp.push(program);
        } else {
            temp.splice(index, 1);
        }
        setAddedProgram(temp);
    }

    const updateChoosenPrograms = (program) => {
        let temp = [...choosenPrograms];
        const index = temp.findIndex((p) => p.id === program.id);
        if (index === -1) {
            temp.push(program);
            setChoosenProgramIDs([...choosenProgramIDs, (program.id + "-" + program.level)]);
        } else {
            temp.splice(index, 1);
            let temp2 = [...choosenProgramIDs];
            temp2.splice(index, 1);
            setChoosenProgramIDs([...temp2]);
        }
        setChoosenPrograms(temp);
        props?.setAddedPrograms(temp);
    }

    const updateAddedProgramIDs = (program) => {
        let temp = [...addedProgramIDs];
        const index = temp.findIndex((p) => p === program);
        if (index === -1) {
            temp.push(program);
        } else {
            temp.splice(index, 1);
        }
        setAddedProgramIDs(temp);
    }

    useEffect(() => {
        props.GetPrograms();
    }, []);

    useEffect(() => {
        const programs = props?.Program?.programs;
        if (programs?.length > 0) {
            let temp = [];
            for (let x = 0; x < programs.length; x++) {
                if (programs?.[x]?.beginner) temp.push({
                    ...programs?.[x],
                    level: 1,
                });
                if (programs?.[x]?.moderate) temp.push({
                    ...programs?.[x],
                    level: 2,
                });
                if (programs?.[x]?.advanced) temp.push({
                    ...programs?.[x],
                    level: 3,
                });
                if (!programs?.[x]?.beginner && !programs?.[x]?.moderate && !programs?.[x]?.advanced) temp.push({
                    ...programs?.[x],
                    level: 0,
                });
            }

            const sortPrograms = (programs) => {
                const seen = new Set();
                const topFour = programs.filter(p => seen.size < 4 && !seen.has(p.type) && seen.add(p.type));
                const remaining = programs.filter(p => !topFour.includes(p));
                return [...topFour, ...remaining];
            }

            setArrangedPrograms(sortPrograms(temp));
        }
    }, [props?.Program?.programs]);

    let useSlide = true;
    let enable = addedProgram.length > 0 || choosenPrograms.length > 0;
    let header = ["", "", `WELCOME ${props?.preRegistrationDetails?.personalInfo?.firstName?.toUpperCase()?.trimEnd()}`, "Ready to Keep Moving?"];
    let description = ["", "", "To get started, choose at least one program. You can add more in the future.", "Add or remove programs from your schedule to make your perfect exercise routine."];
    const isInResurvey = location.pathname.includes("/user-survey");
    const isInOnboarding = location.pathname.includes("/user-onboarding");

    const allAddedPrograms = [...addedProgram, ...choosenPrograms];
    const programIsFull = ((isInResurvey || isInOnboarding) && allAddedPrograms?.length >= 3);

    return (
        <div id="uo-select-program" className={`uo-component ${programIsFull ? "programs-full" : ""} ${isInResurvey ? "uo-sp-resurvey" : ""} ${isInOnboarding ? "uo-sp-onboarding" : ""}`}>
            <div id="program-intro-v2" className="program-detail">
                <div id="onboarding-v2" className="content-area">
                    <PaddedContentArea>
                        <>
                            {(useSlide || !selectedProgram) && (
                                <div id="onb-v2-programs">
                                    <div id="onb-v2-header">
                                        <div id="onb-v2-header-wrapper">
                                            <>
                                                <h4>{header[displayType]}</h4>
                                                <body>{description[displayType]}</body>
                                            </>
                                        </div>
                                    </div>

                                    {/* <div id="onb-v2-list-header">
                                        <h5>Your Programs</h5>
                                    </div> */}
                                    <ProgramsList
                                        title={"Your Programs"}
                                        programs={arrangedPrograms}
                                        setSelectedProgram={(data) => {
                                            if (displayType == 2) {
                                                clearTimeout(delaySlide);
                                                setSelectedProgram(data);
                                                setSlide(true);
                                                props.setShowIndicator(false);
                                            } else if (displayType == 3) {
                                                // setSelectedProgram2(data);
                                                // props.SetModalProperties({
                                                //     height: "450px",
                                                //     isShow: true,
                                                //     title: "",
                                                //     body: <>
                                                //         <ChooseProgram
                                                //             program={data}
                                                //             choosenProgramIDs={choosenProgramIDs}
                                                //             confirm={() => {
                                                //                 updateChoosenPrograms(data);
                                                //             }}
                                                //             exit={() => {
                                                //                 props.ShowModal(false);
                                                //             }}
                                                //         />
                                                //     </>,
                                                //     actions: [],
                                                // });
                                                updateChoosenPrograms(data);
                                            }
                                        }}
                                        screenSize={screenSize}
                                        addedProgram={addedProgram}
                                        selectedPrograms={addedProgramIDs}
                                        choosenPrograms={choosenPrograms}
                                        choosenProgramIDs={choosenProgramIDs}
                                        displayType={displayType}
                                    />

                                    {isInResurvey && <ProgramsList
                                        title={"Explore More Programs"}
                                        programs={arrangedPrograms}
                                        setSelectedProgram={(data) => {
                                            if (!data?.added) {
                                                clearTimeout(delaySlide);
                                                setSelectedProgram(data);
                                                setSlide(true);
                                                props.setShowIndicator(false);
                                            } else {
                                                const id = data?.id + "" + (data?.level && data?.level != 0 ? "-" + data?.level : "");
                                                setAddedProgram(removeItemInArray(addedProgram, [data], ["id", "level"]));
                                                setAddedProgramIDs(removeItemInArray(addedProgramIDs, [id], []));

                                                // if (displayType == 2) {
                                                //     clearTimeout(delaySlide);
                                                //     setSelectedProgram(data);
                                                //     setSlide(true);
                                                //     props.setShowIndicator(false);
                                                // } else if (displayType == 3) {
                                                //     setSelectedProgram2(data);
                                                //     props.SetModalProperties({
                                                //         height: "450px",
                                                //         isShow: true,
                                                //         title: "",
                                                //         body: <>
                                                //             <ChooseProgram
                                                //                 program={data}
                                                //                 choosenProgramIDs={choosenProgramIDs}
                                                //                 confirm={() => {
                                                //                     updateChoosenPrograms(data);
                                                //                 }}
                                                //                 exit={() => {
                                                //                     props.ShowModal(false);
                                                //                 }}
                                                //             />
                                                //         </>,
                                                //         actions: [],
                                                //     });
                                                // }
                                            }
                                        }
                                        }
                                        screenSize={screenSize}
                                        addedProgram={addedProgram}
                                        selectedPrograms={addedProgramIDs}
                                        displayType={4}
                                    />}

                                </div>
                            )}

                            {(useSlide) && (
                                // {(useSlide && displayType == 2) && (
                                <div id="slider-modal-div" style={{ top: slide ? "0" : "100%" }}>
                                    <PaddedContentArea>
                                        <CloseButton
                                            onClick={() => {
                                                setSlide(false);
                                                delay(() => {
                                                    props.setShowIndicator(true);
                                                    setSelectedProgram(null);
                                                }, 300);
                                            }}
                                        />
                                        {selectedProgram && (
                                            <ProgramDetail
                                                updateAddedPrograms={updateAddedPrograms}
                                                selectedProgram={selectedProgram}
                                                setSelectedProgram={setSelectedProgram}
                                                setAddedProgram={() => {
                                                    updateAddedProgramIDs(selectedProgram?.id + "" + (selectedProgram?.level && selectedProgram?.level != 0 ? "-" + selectedProgram?.level : ""))
                                                    setAddedProgram([...addedProgram, { ...selectedProgram, added: true }]);
                                                    setSlide(false);
                                                    setDelay(
                                                        delay(() => {
                                                            props.setShowIndicator(true);
                                                            setSelectedProgram(null);
                                                        }, 300)
                                                    );
                                                }}
                                                screenSize={screenSize}
                                                back={() => {
                                                    setSlide(false);
                                                    setDelay(
                                                        delay(() => {
                                                            props.setShowIndicator(true);
                                                            setSelectedProgram(null);
                                                        }, 300)
                                                    );
                                                }}
                                            />
                                        )}
                                    </PaddedContentArea>
                                </div>
                            )}
                        </>
                    </PaddedContentArea>
                </div>


                <CustomButton disabled={!enable} id="uo-sg-button" className="uo-button active" onClick={async () => {

                    if (displayType == 2) {
                        props?.moveNext();
                        props?.setPreRegistrationDetails(prd => ({
                            ...prd,
                            programs: addedProgram
                        }));

                        const res = await props?.GenerateSchedule({
                            ...props?.preRegistrationDetails,
                            programs: addedProgram,
                            sessionID: userSessionID,
                        });

                        props?.setScheduleID(res)
                        localStorage.setItem("wp-id-temp", res);
                    } else if (displayType == 3) {
                        const allP = [...choosenPrograms, ...(addedProgram.map(ap => {
                            return {
                                ...ap,
                                isNew: true
                            }
                        }))];
                        props?.moveNext(allP);
                    }
                }}>Continue</CustomButton>

                {/* <CustomModalWrapper /> */}

            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetPrograms,
    GenerateSchedule,
    SetModalProperties,
    ShowModal,
})(SlideSelectProgram);